import React from 'react';
import { Link } from 'react-router-dom';
import ChevronRightIcon from '../icons/ChevronRightIcon';

const ViewLink = ({to, children, className = '', compact = false}) => {
    const sizeClasses = compact
        ? 'px-1 py-1 text-xs'
        : 'px-4 py-2 text-sm min-h-[38px]';

    return (
        <Link 
            to={`/location/${to}/forecast`}
            className={`view-link inline-flex items-center justify-center gap-1 shrink-0 whitespace-nowrap font-bold text-custom-light-blue hover:text-custom-light-blue/80 transition-colors cursor-pointer ${sizeClasses} ${className}`}
        >
            {children}
            <ChevronRightIcon />
        </Link>
    );
};

export default ViewLink;
